<!-- Action Bar -->
<div class="wishlist-action-bar flex items-center gap-4 sm:mx-4 mx:mx-8 mt-4 mb-4 pb-4 border-b border-grey">
  <!-- Select All Checkbox -->
  <label
    nz-checkbox
    [(ngModel)]="allChecked"
    (ngModelChange)="selectAll($event)"
    class="flex items-center"
  >
    <span class="ml-2 text-base">{{ "SELECT_ALL" | translate }}</span>
  </label>
  
  <!-- Action Buttons -->
  <div class="flex items-center gap-4 ml-auto">
    <button
      nz-button
      nzType="default"
      [disabled]="isOperation()"
      (click)="moveToCart()"
      class="flex items-center gap-2"
    >
      <svg-icon
        [iconName]="'cart.svg'"
        [size]="18"
        class="color-grey"
        [isUrl]="false"
      ></svg-icon>
      <span>{{ "MOVE_TO_CART" | translate }}</span>
    </button>
    <button
      nz-button
      nzType="default"
      [disabled]="isOperation()"
      (click)="deleteAll()"
      class="flex items-center gap-2"
    >
      <svg-icon
        [iconName]="'wishlist_del.svg'"
        [size]="18"
        class="color-grey"
      ></svg-icon>
      <span>{{ "DELETE" | translate }}</span>
    </button>
  </div>
</div>

<!-- Table -->
<div class="result-table sm:mx-4 mx:mx-8">
  <nz-table
    #fixedTable
    nzTableLayout="auto"
    [nzFrontPagination]="false"
    [nzShowPagination]="wishList.length > 10"
    [nzPageSize]="10"
    [nzData]="wishList"
    [nzScroll]="{ x: 'max-content' }"
    class="wishlist-table"
  >
    <thead>
      <tr>
        <th nzWidth="60" class="text-center">
          <label
            nz-checkbox
            [(ngModel)]="allChecked"
            (ngModelChange)="selectAll($event)"
          ></label>
        </th>
        <th nzWidth="200" class="text-left sm:hidden">{{ "ENTERED_MATERIAL_NO" | translate }}</th>
        <th nzWidth="200" class="text-left">{{ "MATERIA_NUM" | translate }}</th>
        <th nzWidth="150" class="text-center">{{ "QUANTITY" | translate }}</th>
        <th nzWidth="120" class="text-center">{{ "ACTION" | translate }}</th>
      </tr>
    </thead>
    <tbody class="order text">
      <tr *ngFor="let data of fixedTable.data" class="hover:bg-gray-50">
        <td nzWidth="60" class="text-center">
          <label
            nz-checkbox
            [(ngModel)]="data.check"
            (ngModelChange)="updateAllChecked()"
          ></label>
        </td>
        <td nzWidth="200" class="text-left sm:hidden">
          <div class="truncate" [title]="data.inputMaterialNumber">
            {{ data.inputMaterialNumber }}
          </div>
        </td>
        <td nzWidth="200" class="text-left">
          <div class="truncate" [title]="data.materialNumber || data.inputMaterialNumber">
            {{ data.materialNumber || data.inputMaterialNumber }}
          </div>
        </td>
        <td nzWidth="150" class="text-center">
          <quantity-input
            mode="wishList"
            [inputQuantity]="data.quantity"
            [(quantity)]="data.quantity"
            [errorTypes]="[]"
            (quantityBlur)="quantityBlur($event, data)"
            (quantityChange)="quantityChange($event, data)"
          ></quantity-input>
        </td>
        <td nzWidth="120" class="text-center">
          <div class="flex items-center justify-center gap-2">
            <svg-icon
              [iconName]="'cart.svg'"
              [title]="'MOVE_TO_CART' | translate"
              class="cursor-pointer hover:opacity-70 transition-opacity"
              [size]="20"
              (click)="moveToCart([data.id])"
            ></svg-icon>
          </div>
        </td>
      </tr>
      <tr *ngIf="wishList.length === 0">
        <td [attr.colspan]="5" class="text-center py-8">
          <div class="flex flex-col items-center justify-center">
            <img src="assets/no-data.svg" class="mb-4" style="width: 120px; height: 120px;" />
            <div class="text-gray-500 text-base">{{ "WISHLIST_EMPTY" | translate }}</div>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
